import { PrivacyStatementPage } from "./PrivacyStatementPage";

export const PrivacyStatement = () => {
  return <PrivacyStatementPage />;
};
